import { I18n } from '@ngx-translate/i18n-polyfill';
import { Component, OnInit, ViewChild, Input, Output, EventEmitter, AfterViewInit, OnChanges, SimpleChanges } from '@angular/core';
import { MatPaginator, MatSort, MatDialog } from '@angular/material';
import { Legislacio } from '../../models/legislacio.model';
import { CustomDataSource } from 'path-shared/services/datasource/custom.datasource';
import { LegislacioFilter } from '../../models/legislacio-filter';
import { FilterService } from 'path-shared/services/filter/filter.service';
import { LegislacionsFilterService } from '../../services/legislacions-filter-service';
import { merge } from 'rxjs';
import { tap } from 'rxjs/operators';
import { DownloadExcelDialogComponent } from 'path-shared/components/dialogs/download-excel-dialog/download-excel-dialog.component';
import { LegislacioService } from '../../services/legislacions-service.service';
import { Builder } from 'path-shared/models/builder';

@Component({
  selector: 'app-legislacions-table',
  templateUrl: './legislacions-table.component.html',
  styleUrls: ['./legislacions-table.component.scss']
})
export class LegislacionsTableComponent implements OnInit, AfterViewInit, OnChanges {

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  data: Legislacio[];
  dataSource: CustomDataSource<Legislacio, LegislacioFilter>;
  filter: LegislacioFilter = new LegislacioFilter('codi', 'asc');
  displayedItems = [];
  highlightedRows = [];

  @Input() selectButton: boolean;
  @Input() updatedFilterData: LegislacioFilter;
  @Output() notify: EventEmitter<number> = new EventEmitter<number>();
  @Output() itemClicked: EventEmitter<string> = new EventEmitter<string>();
  @Output() itemSelected: EventEmitter<string> = new EventEmitter<string>();

  displayedColumns = ['codi', 'descripcio', 'obsoleta', 'trafic'];

  constructor(
    private legislacioService: LegislacioService,
    private filterService: FilterService,
    private dialog: MatDialog,
    private i18n: I18n
  ) {
  }

  ngOnInit() {
    this.sort.disableClear = true;
    this.dataSource = CustomDataSource.create<Legislacio, LegislacioFilter>(this.paginator, new LegislacionsFilterService(), 'urlGetLegislacions', 'urlGetCountLegislacions');
    this.dataSource.subject.subscribe((data) => {
      data.forEach(item => {
        this.displayedItems[item.secureId] = {
          id: item.secureId
        };
      });
    });

    this.filter.filterUpdated.subscribe(updated => {
      if (updated) {
        this.load();
        if (!this.selectButton) { this.filterService.saveFilter('legislacions-filter', this.filter); }
      }
    });

    if (!this.selectButton) { this.filterService.loadFilter('legislacions-filter', this.filter); }
    this.filter.paginator.init(this.sort, this.paginator);
  }

  ngAfterViewInit() {
    // reset the paginator after sorting
    this.sort.sortChange.subscribe(() => {
      this.paginator.pageIndex = 0;
      this.filter.paginator.set(this.sort, this.paginator);
      this.filter.updated();
    });

    merge(this.sort.sortChange, this.paginator.page)
    .pipe(tap(() => this.filter.updated()))
    .subscribe();

    this.load();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.updatedFilterData != null) {
      this.update();
    }
  }

  update() {
    if (this.dataSource !== undefined) {
      this.updatedFilterData.paginator.set(this.sort, this.paginator);
      this.dataSource.loadFilter(this.updatedFilterData);
    }
  }

  load() {
    this.filter.paginator.set(this.sort, this.paginator);
    this.dataSource.loadFilter(this.filter);
  }

  onRowClicked(row) {
    this.itemClicked.next(row.secureId);
  }

  generateExcel(): void {
    let filter = this.filter;
    if (this.updatedFilterData != null) {
      filter = this.updatedFilterData;
    }
    this.dialog.open(DownloadExcelDialogComponent, {
        closeOnNavigation: false,
        autoFocus: true,
        data: Builder.newDownloadExcelDialogData (this.legislacioService, filter, this.i18n('Legislacions'), this.sort.direction, this.sort.active)
    });
  }

}
